import React, { FC } from 'react';

import { useCoreViewerContext } from '../../../context/CoreViewerContext';
import { OneToOneIcon } from '../../icons/OneToOneIcon';
import { ZoomOutIcon } from '../../icons/ZoomOutIcon';

import styles from './index.module.scss';

export const StatusBarItemZoom: FC = () => {
	const { setZoom, zoom, fitToWindow } = useCoreViewerContext();

	return (
		<div data-statusbar-item-type="zoom" className={styles.item}>
			<div className={styles.buttons}>
				<button className={styles.iconButton} onClick={() => fitToWindow()} title="Fit to window">
					<ZoomOutIcon />
				</button>
				<button className={styles.iconButton} onClick={() => setZoom(1)} title="Zoom to 100%">
					<OneToOneIcon />
				</button>
			</div>
			<input
				className={styles.slider}
				name="zoom"
				min={0}
				max={200}
				step={10}
				value={zoom * 100}
				type="range"
				onChange={(e) => setZoom(e.target.valueAsNumber / 100)}
			/>
			<span className={styles.percentage}>{(zoom * 100).toFixed(0)}%</span>
		</div>
	);
};
